// extracted by mini-css-extract-plugin
export default {"filters":"TableFilters_filters__5ap45"};